import { asin, sqrt } from "../math.js";
import { azimuthalRaw, azimuthalInvert } from "./azimuthal.js";
import projection from "./index.js";
export var azimuthalEqualAreaRaw = azimuthalRaw(function (cxcy) {
    return sqrt(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = azimuthalInvert(function (z) {
    return 2 * asin(z / 2);
});
export default function () {
    return projection(azimuthalEqualAreaRaw)
        .scale(124.75)
        .clipAngle(180 - 1e-3);
}
